import {Component, Input,} from '@angular/core';
import {TranslocoService} from '@ngneat/transloco';
import {Country, EventItem, Lookups} from "@model";
import {LocalizedDatePipe} from "@pipes";
import {animate, state, style, transition, trigger} from "@angular/animations";
import {LiveResultHeadingType} from "../live-results-race-heading/live-results-race-heading.component";
import {AbstractComponent} from "../abstract.component";


@Component({
  selector: 'app-live-event',
  templateUrl: './live-event.component.html',
  styleUrls: ['./live-event.component.scss'],
  animations: [
    trigger('toBottom', [
      state('in', style({height: '*'})),
      transition(':enter', [
        style({height: '0', overflow: 'hidden'}),
        animate('300ms ease-out', style({height: '*'}))
      ]),

      state('out', style({height: '0'})),
      transition(':leave', [
        style({height: '*', overflow: 'hidden'}),
        animate('300ms ease-out', style({height: '0'}))
      ])
    ])]
})
export class LiveEventComponent extends AbstractComponent {

  @Input() liveEvent: EventItem | undefined;
  @Input({required: true}) languages: Lookups[] = [];
  @Input({required: true}) countries: Country[] = [];

  localizedDatePipe: LocalizedDatePipe;
  isExpanded: boolean = false;

  constructor(public translocoService: TranslocoService,
  ) {
    super();
    this.localizedDatePipe = new LocalizedDatePipe(translocoService);
  }

  ngOnInit() {
  }

  expand() {
    this.isExpanded = !this.isExpanded;
  }


  protected readonly LiveResultHeadingType = LiveResultHeadingType;
}
